import * as React from 'react'

const IconFullActivity = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M3.4 5a.4.4 0 0 0-.4.4v12.336c0 .221.18.4.4.4h17.2a.4.4 0 0 0 .4-.4V5.4a.4.4 0 0 0-.4-.4H3.4zm0-.7h17.2a1.1 1.1 0 0 1 1.1 1.1v12.336a1.1 1.1 0 0 1-1.1 1.1H3.4a1.1 1.1 0 0 1-1.1-1.1V5.4a1.1 1.1 0 0 1 1.1-1.1zm.58 1.222h16.04a.44.44 0 0 1 .44.44v11.213a.44.44 0 0 1-.44.44H3.98a.44.44 0 0 1-.44-.44V5.962a.44.44 0 0 1 .44-.44z'
      fill='#FFF'
    />
  </svg>
)

export default IconFullActivity
